const pairingsActionTypes = {
  FETCH_CHALLENGE_PAIRINGS_START: "FETCH_CHALLENGE_PAIRINGS_START",
  FETCH_CHALLENGE_PAIRINGS_SUCCESS: "FETCH_CHALLENGE_PAIRINGS_SUCCESS",
  FETCH_CHALLENGE_PAIRINGS_FAILURE: "FETCH_CHALLENGE_PAIRINGS_FAILURE",

  FETCH_MY_PAIR_STATUS_START: "FETCH_MY_PAIR_STATUS_START",
  FETCH_MY_PAIR_STATUS_SUCCESS: "FETCH_MY_PAIR_STATUS_SUCCESS",
  FETCH_MY_PAIR_STATUS_FAILURE: "FETCH_MY_PAIR_STATUS_FAILURE",

  SUBMIT_LOSERS_START: "SUBMIT_LOSERS_START",
  SUBMIT_LOSERS_SUCCESS: "SUBMIT_LOSERS_SUCCESS",
  SUBMIT_LOSERS_FAILURE: "SUBMIT_LOSERS_FAILURE",

  UPDATE_LOSERS_START: "UPDATE_LOSERS_START",
  UPDATE_LOSERS_SUCCESS: "UPDATE_LOSERS_SUCCESS",
  UPDATE_LOSERS_FAILURE: "UPDATE_LOSERS_FAILURE",

  SUBMIT_WINNERS_START: "SUBMIT_WINNERS_START",
  SUBMIT_WINNERS_SUCCESS: "SUBMIT_WINNERS_SUCCESS",
  SUBMIT_WINNERS_FAILURE: "SUBMIT_WINNERS_FAILURE",

  UPDATE_WINNERS_START: "UPDATE_WINNERS_START",
  UPDATE_WINNERS_SUCCESS: "UPDATE_WINNERS_SUCCESS",
  UPDATE_WINNERS_FAILURE: "UPDATE_WINNERS_FAILURE",

  CHECK_ROUND_COMPLETION_START: "CHECK_ROUND_COMPLETION_START",
  CHECK_ROUND_COMPLETION_SUCCESS: "CHECK_ROUND_COMPLETION_SUCCESS",
  CHECK_ROUND_COMPLETION_FAILURE: "CHECK_ROUND_COMPLETION_FAILURE",

  SET_SELECTED_ROUND: "SET_SELECTED_ROUND",
  SET_SELECTIONS: "SET_SELECTIONS",
  CLEAR_SELECTIONS: "CLEAR_SELECTIONS",
  CLEAR_PAIRINGS: "CLEAR_PAIRINGS",

  FETCH_ALL_PAIRINGS_START: "FETCH_ALL_PAIRINGS_START",
  FETCH_ALL_PAIRINGS_SUCCESS: "FETCH_ALL_PAIRINGS_SUCCESS",
  FETCH_ALL_PAIRINGS_FAILURE: "FETCH_ALL_PAIRINGS_FAILURE",

  FETCH_USER_PAIRINGS_START: "FETCH_USER_PAIRINGS_START",
  FETCH_USER_PAIRINGS_SUCCESS: "FETCH_USER_PAIRINGS_SUCCESS",
  FETCH_USER_PAIRINGS_FAILURE: "FETCH_USER_PAIRINGS_FAILURE",

  FETCH_CREATOR_PAIRINGS_START: "FETCH_CREATOR_PAIRINGS_START",
  FETCH_CREATOR_PAIRINGS_SUCCESS: "FETCH_CREATOR_PAIRINGS_SUCCESS",
  FETCH_CREATOR_PAIRINGS_FAILURE: "FETCH_CREATOR_PAIRINGS_FAILURE",

  VERIFY_LOSERS_START: "VERIFY_LOSERS_START",
  VERIFY_LOSERS_SUCCESS: "VERIFY_LOSERS_SUCCESS",
  VERIFY_LOSERS_FAILURE: "VERIFY_LOSERS_FAILURE",

  VERIFY_WINNERS_START: "VERIFY_WINNERS_START",
  VERIFY_WINNERS_SUCCESS: "VERIFY_WINNERS_SUCCESS",
  VERIFY_WINNERS_FAILURE: "VERIFY_WINNERS_FAILURE",

  FETCH_PAIRS_WINNERS_START: "FETCH_PAIRS_WINNERS_START",
  FETCH_PAIRS_WINNERS_SUCCESS: "FETCH_PAIRS_WINNERS_SUCCESS",
  FETCH_PAIRS_WINNERS_FAILURE: "FETCH_PAIRS_WINNERS_FAILURE",
};

export default pairingsActionTypes;
